import { render, staticRenderFns } from "./LuckyWheel.vue?vue&type=template&id=a28001a6&scoped=true"
import script from "./LuckyWheel.vue?vue&type=script&lang=js"
export * from "./LuckyWheel.vue?vue&type=script&lang=js"
import style0 from "./LuckyWheel.vue?vue&type=style&index=0&id=a28001a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28001a6",
  null
  
)

export default component.exports